import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Button, Form, Modal } from "react-bootstrap";
import { postData } from "../../axios/apiHelper";
import { ENDPOINT } from "../../axios/apiConfig";
import { loader } from "../../loader";
import { toast } from "react-toastify";
import { getEventCollection } from "../../actions";
import { connect } from "react-redux";

var eventsetupData = {};
const EventCollectionCreate = (props) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

    const navigate = useNavigate();
    
    const [error, setError] = useState({});
    const [show, setShow] = useState(false);
    const [newTag, setNewTag] = useState("");
    const [allTags, setAllTags] = useState([]);
    const [tagsCounter, setTagsCounter] = useState(0);
    const [modalCounter, setModalCounter] = useState(0);
    const [tagsReRender, setTagsReRender] = useState(0);

    const [tagClickedFirst, setTagClickedFirst] = useState(
        eventsetupData?.setUpData?.tags ? eventsetupData.setUpData.tags : []
    );
    const [finalTags, setFinalTags] = useState(
        eventsetupData?.setUpData?.tags ? eventsetupData.setUpData.tags : []
    );

    const [formData, setformData] = useState({
        collectionTitle: eventsetupData?.setUpData?.title
            ? eventsetupData.setUpData.title
            : "",
        eventCollectionfinalTags: eventsetupData?.setUpData?.tags
            ? eventsetupData.setUpData.tags
            : finalTags,
    });

    useEffect(() => {
        getAllTags();
    }, []);

    const getAllTags = async () => {
        loader("show");
        try {
            const response = await postData(`${ENDPOINT.GETALLTOPICS}`);
            const allTags = response?.data?.data;
            setAllTags(allTags);
        } catch (err) {
            console.error("Error fetching blocked users:", error);
        } finally {
            loader("hide");
        }
    };

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setformData((prev) => ({...prev,[name]: value}));
        setError((prev) => ({
        ...prev,
        [name]: "",
        }));
    };

    const handleShow = () => {
        setShow(true);
        setModalCounter(modalCounter + 1);
    };

    const handleClose = () => {
        resetState(setNewTag);
        setShow(false);
        setError((prev)=>({...prev,newTag:""}))
    };

    function resetState(setfun) {
        setfun("");
    }

    const tagClicked = (dd) => {
        if (!tagClickedFirst.includes(dd)) {
          setTagClickedFirst((oldArray) => [...oldArray, dd]);
        } else {
          toast.error("Topic already in list.");
        }
    };

    const removeTagFinal = (index) => {
        const tags = finalTags;
        const tagsClickedFirst = tagClickedFirst;
        tags.splice(index, 1);
        tagsClickedFirst.splice(index, 1);
        setFinalTags(tags);
        setTagClickedFirst(tagsClickedFirst);
        setTagsReRender(tagsReRender + 1);
    };

    const removeTag = (index) => {
        const tags = tagClickedFirst;
        tags.splice(index, 1);
        setTagClickedFirst(tags);
        setFinalTags(tags);
        setTagsReRender(tagsReRender + 1);
    };

    const newTagChanged = (e) => {
        setNewTag(e.target.value);
        e.target.value = "";
        const new_atg = document.getElementById("new-tag");
        new_atg.value = "";
        setError((prev) => ({...prev,newTag: ""}));
    };

    const addTag = async () => {
        if (typeof newTag == "undefined" || newTag.trim().length === 0) {
            setError((prev) => ({...prev,newTag: "Please enter a Topic"}));
        } else {
            let temp_tags = tagClickedFirst.map((data) => {
                return data.toLowerCase();
            });
            let alltemp_tags = [];

            if (typeof allTags != "undefined") {
                Object.entries(allTags)?.map((data) => {
                return alltemp_tags.push(...data);
                });
                alltemp_tags = alltemp_tags?.map((data) => {
                return data.toLowerCase();
                });
            }

            if (
                !temp_tags.includes(newTag.toLowerCase()) &&
                !alltemp_tags.includes(newTag.toLowerCase())
            ) {
                try {
                    loader("show");
                    await postData(ENDPOINT.ADD_SPC_PRODUCT, {
                    user_id: localStorage.getItem("user_id"),
                    product: newTag?.trim(),
                    category: 0,
                    type: 2,
                    });
                    loader("hide");
                } catch (err) {
                    console.log(err);
                } finally{
                    loader("hide");
                }
                setTagClickedFirst((oldArray) => [...oldArray, newTag]);
                setAllTags((oldArray) => [...oldArray, newTag]);
            } else {
                toast.error("Topic already in list.");
            }
            setNewTag("");
            setTagsCounter(tagsCounter + 1);
        }
    };

    const saveButtonClicked = () => {
        if (finalTags.length == 0 && tagClickedFirst.length == 0) {
          toast.error("No topics selected");
          return;
        }
        if (typeof finalTags != "undefined" && finalTags.length > 0) {
          let prev_tags = finalTags;
          let new_tags = prev_tags.concat(tagClickedFirst);
          const uniqueTags = new_tags.filter((x, i, a) => a.indexOf(x) === i);
          setFinalTags(uniqueTags);
          setformData((prev) => ({
            ...prev,
            eventCollectionfinalTags: uniqueTags,
          }));
        } else {
          setFinalTags(tagClickedFirst);
          setformData((prev) => ({
            ...prev,
            eventCollectionfinalTags: tagClickedFirst,
          }));
        }
        handleClose();
    };

    const onNextClick = async (e) => {
        e.preventDefault();
        // var handleError = surveyValidation(formData);
        // if (Object.keys(handleError).length > 0) {
        //   setError(handleError);
        //   return "";
        // }
    
        try {
          const currentPageData = {
            title: formData?.collectionTitle,
            tags: formData.eventCollectionfinalTags,
          };
          props.getEventCollection({
            ...eventsetupData,
            setUpData: {...eventsetupData?.setUpData, ...currentPageData },
          });
          navigate("/webinar/event/event-collection-content");
        } catch (error) {
          console.log(error);
          loader("hide");
          toast.error("Something went wrong");
        }
    };
    
    return (
        <>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <Col className="right-sidebar custom-change event-collection">
                        <div className="d-flex flex-column justify-content-center">
                            <div className="top-right-action preview">
                                <div className="d-flex flex-column w-100">
                                    <div className="page-top-nav sticky">
                                        <Row className="justify-content-end align-items-center">
                                            <Col md={2}></Col>
                                            <Col md={8}>
                                                <ul className="tabnav-link">
                                                    <li className="active active-main">
                                                        <Link to="">Select your content collection</Link>
                                                    </li>
                                                    <li className="">
                                                        <Link to="">Set-up collection page</Link>
                                                    </li>
                                                    <li className="">
                                                        <Link to="">Set-Up Registration pop-up</Link>
                                                    </li>
                                                </ul>
                                            </Col>
                                            <Col md={2}>
                                                <div className="header-btn">
                                                    <Link
                                                        className="btn btn-primary btn-bordered move-draft"
                                                        to="/webinar/event/event-collection"
                                                    >
                                                        Cancel
                                                    </Link>
                                                    <Button
                                                        className= {`${formData?.collectionTitle?.trim()?.length > 0 ? "btn btn-primary btn-filled next" : "btn btn-primary btn-filled next disabled"}`}
                                                        onClick={(e) => {onNextClick(e)}}
                                                    >
                                                        Next
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                            <div className="survey-setup d-flex w-100 flex-column">
                                <div className="survey-create">
                                    <Form className="row">
                                    <Form.Group className="col-md-12 form-group">
                                        <Form.Label>
                                        Content collection title <span>*</span>
                                        </Form.Label>
                                        <Form.Control
                                        type="text"
                                        name="collectionTitle"
                                        value={formData.collectionTitle}
                                        onChange={(e) => changeHandler(e)}
                                        placeholder="Title of the collection"
                                        />
                                        <div className="login-validation">
                                        {error?.collectionTitle ? error.collectionTitle : ""}
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="col-md-12 form-group">
                                    <div className="input-group d-flex flex-row-reverse w-100 align-items-center">
                                        <div className="input-group-prepend">
                                        <Button className="btn-bordered" onClick={handleShow}>
                                            Add Topic +
                                        </Button>
                                        </div>
                                        <div className="tags_added">
                                            {
                                                finalTags?.length == 0 && (
                                                    <div className="no-topics text-center">No topics added yet</div>
                                                )
                                            }
                                        <ul>
                                            {finalTags.map((tags, index) => (
                                            <li className="list1" key={index}>
                                                {tags.innerHTML || tags}{" "}
                                                <img
                                                src={path_image + "filter-close.svg"}
                                                alt="Close-filter"
                                                onClick={() => removeTag(index)}
                                                />
                                            </li>
                                            ))}
                                        </ul>
                                        </div>
                                    </div>
                                    </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </div>
            </Col>

            <Modal
                id="tagsModal"
                show={show}
                onHide={handleClose}
                backdrop="static"
                className="survey-modal"
            >
                <Modal.Header>
                    <h5 className="modal-title" id="staticBackdropLabel">
                        Add Topics
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </Modal.Header>
                <Modal.Body>
                    <div className="select-tags">
                        <h6>Select Topics :</h6>
                        <div className="tag-lists">
                            <div className="tag-lists-view">
                                {allTags
                                    ? Object.values(allTags)?.map((data, index) => (
                                        <div key={index} onClick={() => tagClicked(data)}>
                                            {data}{" "}
                                        </div>
                                    ))
                                    : ""}
                            </div>
                        </div>
                    </div>
                    <div className="selected-tags">
                        <h6>
                            Selected Topics  <span>| {tagClickedFirst.length}</span>
                        </h6>

                        <div className="total-selected">
                            {tagClickedFirst.map((data, index) => (
                                <div className="tag-cross" key={index}>
                                    {data.innerHTML || data}
                                    <img
                                        src={path_image + "filter-close.svg"}
                                        alt="Close-filter"
                                        onClick={() => removeTagFinal(index)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <form>
                        <div className="form-group">
                            <label htmlFor="new-tag">New Topic</label>
                            <div className="d-flex flex-column align-items-start">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="new-tag"
                                    value={newTag}
                                    onChange={(e) => newTagChanged(e)}
                                />
                                <div className="login-validation">
                                    {error?.newTag ? error?.newTag : ""}
                                </div>
                            </div>

                            <button
                                type="button"
                                className="btn btn-primary add btn-bordered"
                                onClick={addTag}
                            >
                                Add
                            </button>
                        </div>
                    </form>
                    <button
                        type="button"
                        className="btn btn-primary save btn-filled"
                        onClick={saveButtonClicked}
                    >
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

const mapStateToProps = (state) => {
  eventsetupData = state?.getEventCollection;
  return state;
};

export default connect(mapStateToProps, { getEventCollection: getEventCollection })(
  EventCollectionCreate
);
